import { ILanguage, Language } from "@/services/DTOs";
import { OpportunitiesApiService } from "@/services/OpportunitiesApiService";

import { Observable } from "rxjs";
import { map, publishReplay, refCount } from "rxjs/operators";

class Service {

  private allObservable: {
    [code: string]: Observable<Language[]>
  } = {};

  public all(locale: string): Observable<Language[]> {
    if (!this.allObservable[locale]) {
      this.allObservable[locale] = this.search(locale).pipe(publishReplay(), refCount());
    }

    return this.allObservable[locale];
  }

  public search(locale: string, query?: string): Observable<Language[]> {
    const url = "/api/suite/languages";
    const params = new URLSearchParams();

    if (query) {
      params.append("q", query);
    }

    if (locale) {
      params.append("locale", locale);
    }

    return OpportunitiesApiService
      .cancellableGet(url, params)
      .pipe(map((response) => response.data.map((data: ILanguage) => new Language(data))));
  }
}

export const LanguageService = new Service();
